import { z } from 'zod';

export const voltageTypes = ['AC', 'DC'] as const;

export type VoltageType = (typeof voltageTypes)[number];

export const VoltageType = {
    validator: z.enum(voltageTypes),
};
